import React from 'react';

import { ButtonFilter } from 'src/components/FilterControls';
import { useSelectorsApartments } from 'src/components/FilterProperty/hooks';
import { SelectorGeneratorFilter } from './components/SelectorGeneratorFilter';
import { useStyles as useFilterStyles } from './components/ButtonFilter/styles';
import { IComponentMobileFilter } from './types';

export const ComponentMobileFilter: React.FC<IComponentMobileFilter> = ({
  handleModalOpen,
}) => {
  const stylesFilter = useFilterStyles({});
  const {
    filterData,
  } = useSelectorsApartments();

  return (
    <>
      <div className={stylesFilter.modalFilterWrapper}>
        <div className={stylesFilter.modalFilterSelectors}>
          {filterData.map((field, index) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <SelectorGeneratorFilter key={index} dropdownField={field} />
            );
          })}
        </div>
      </div>
      <ButtonFilter
        handleSubmit={handleModalOpen}
      />
    </>
  );
};
